export default __webpack_public_path__ + "static/media/onboarding-video-thumbnail.6352dd75.png";